import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { CostCenterService } from '../share/costCenter/costcenter.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators/finalize';
import { AverageTrafficSummary } from './average-traffic.model';
import { AppSettings } from '../../settings';
import { FilterPipe } from '../pipes/filterPipe';
import { Terminal } from '../share/terminal/zone.model';
import { ReportsService } from '../share/reports/report.service';


@Component({
  selector: 'app-average-traffic',
  templateUrl: './average-traffic.component.html',
  styleUrls: ['./average-traffic.component.css'],
  providers: [CostCenterService, ReportsService, FilterPipe]
})
export class AverageTrafficComponent implements OnInit {
  terminals: Terminal[] = [];
  costCenterId: number = null;
  costCenterTraffic: AverageTrafficSummary;
  p = 1;
  details = -1;
  searchString: string;
  recordsPerPage: number;
  isLoading = false;
  filterValueChanged: EventEmitter<any> = new EventEmitter();
  currencySuffix: string;
  filterValue: string;
  order = 'costCenterId';

  modalRef: BsModalRef;
  constructor(
    private _costCenterService: CostCenterService,
    private _reportService: ReportsService,
    private _spinner: NgxSpinnerService,
    private _settings: AppSettings,
  ) {
    this.currencySuffix = _settings.getCurrencySuffix(new Date());
    this.recordsPerPage = _settings.recordsPerPage;
  }

  ngOnInit() {
    this.getCostCenters();
  }

  onClearAllFilters() {
    this.costCenterId = null;
    this.details = -1;
    this.removeFocus();
  }

  removeFocus() {
    (document.activeElement as HTMLElement).blur();
  }

  onCostCenterChange() {
    this.details = -1;
    this.p = 1;
    this.removeFocus();
  }

  filterBy = (value: string) => {
    this.filterValue = value;
  }

  getCostCenters() {
    this._costCenterService.httpGetUserTerminals()
    .pipe(finalize(() => this._spinner.hide()))
        .subscribe(
          data => {
            if (data !== undefined) {
              this.terminals = data;
            }
          },
          err => {
            throw err;
          });
  }

  getCostCenterTraffic(i: number, costCenterId: number) {
    this.isLoading = true;
    this.details = i;
    this._spinner.show();

    this._reportService.httpGetCostCenterTraffic(costCenterId)
    .pipe(finalize(() => this._spinner.hide()))
        .subscribe(
          data => {
            if (data !== undefined) {
              this.costCenterTraffic = data;
            }
          },
          err => {
            throw err;
          });
  }

  keyDownFunction(event) {
    if (event.key === 'Enter') {
      this.removeFocus();
    }
  }

  filterByOnChange() {
    this.filterValueChanged.emit(this.filterValue);
  }

  sort(propertyName) {
    if (this.details > -1) return;
    if (this.order === propertyName) {
      this.order = '-' + propertyName;
    } else if (this.order === '-' + propertyName) {
      this.order = propertyName;
    } else {
      this.order = propertyName;
    }
  }

  onSearchTextChange(): void {
    if (this.details !== -1) {
      this.details = -1;
    }
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/average-traffic/average-traffic.component.ts